import React, { useState } from 'react';
import { ConfirmationModal, Typography } from 'seagull';
import { useOverlayContext, useStoreActions } from "../../../contexts";
import { handlePromise } from "../../../infra/utils";
export default function RemoveAccountantModal(props) {
  const {
    accountant,
    dismissModal,
    refresh
  } = props;
  const overlayContext = useOverlayContext();
  const {
    api,
    logBI
  } = useStoreActions();
  const [loading, setLoading] = useState(false);
  async function submit() {
    setLoading(true);
    const vendorId = accountant.id();
    logBI(13105, {
      vendorId,
      companyName: accountant.companyName()
    });
    const {
      success
    } = await handlePromise(api.accountants.removeVendor(vendorId));
    if (!success) {
      overlayContext.showErrorToast('Failed to remove Accountant', 'acc-remove-failure');
    } else {
      await refresh();
    }
    dismissModal();
  }
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    skin: "danger",
    textAlignCenter: false,
    title: "Remove accountant",
    primaryButtonLabel: "Remove Accountant",
    primaryButtonTestid: "rm-acc-access-submit",
    primaryButtonLoading: loading,
    secondaryButtonLabel: "Cancel",
    onCloseButtonClick: dismissModal,
    onSecondaryButtonClick: dismissModal,
    onPrimaryButtonClick: submit,
    content: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, null, "Are you sure you want to remove accountant access to", ' ', /*#__PURE__*/React.createElement(Typography, {
      as: "span",
      weight: "normal"
    }, accountant.companyName()), "?"), /*#__PURE__*/React.createElement(Typography, null, "Once removed they will no longer be able to access your business."))
  });
}